import React from 'react';
import './TheTeacherDashboard.css';
import Questions from './imageFiles/Questions.png';
import Categories from './imageFiles/Categories.png';
import Types from './imageFiles/Types.png';
import Library from './imageFiles/Library.png';

export default function TeacherQuestionLibrary({ questionCount, categoryCount, loadingCategories, loadingQuestions, employeeType, typeCount, initial_loading }) {
  const libraryStats = [
    { img: Types, count: typeCount || 0, label: 'My Papers', icon: 'https://via.placeholder.com/50', isLoading: initial_loading },
  ]
  const libraryStatsMASAD = [
    // for data enrty and MASAD
    { img: Questions, count: questionCount || 0, label: 'All Questions', icon: 'https://via.placeholder.com/50', isLoading: loadingQuestions },
    { img: Categories, count: categoryCount || 0, label: 'My Questions', icon: 'https://via.placeholder.com/50', isLoading: loadingCategories },

  ];
  return (
    <div className="teacher-question-library">
      <h6 className="question-library-title ">Questions</h6>
      <div className='library-container'>
        {/* {(employeeType === employeeType === "MASAD" || employeeType === "DEOP") &&
          <img src={Library} alt="Library" className="library-icon" style={{ width: "100%", height: "auto", borderRadius: "8px" }} />
        } */}
        <div className="row gx-3 mb-3">
          {/* for reviwer */}
          {(employeeType === "MASAD" || employeeType === "DEOP") &&
            <div className='col-12 px-0'>
              <div className="">
                {(employeeType === "MASAD" || employeeType === "DEOP") ? (
                  libraryStatsMASAD.map((item, index) => (
                    <div className="col-12 col-md-12 sm-12 py-1 px-0" key={index}>
                      <div className="library-box text-center">
                        <img src={item.img} alt={item.label} className="library-icon mb-2" />
                        {item.isLoading ?
                          <div
                            className="stu-card-title pt-2 col-md-12"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <i className="fas fa-spinner fa-spin"></i>
                          </div>
                          :
                          <div className="library-count">{item.count || 0}</div>
                        }
                        <div className="library-label">{item.label}</div>
                      </div>
                    </div>
                  ))

                ) : (
                  libraryStats.map((item, index) => (
                    <div className="col-12 col-md-6 sm-12" key={index}>
                      <div className="library-box text-center">
                        <img src={item.img} alt={item.label} className="library-icon mb-2" />
                        {item.isLoading ?
                          <div
                            className="stu-card-title pt-2 col-md-12"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <i className="fas fa-spinner fa-spin"></i>
                          </div>
                          :
                          <div className="library-count">{item.count || 0}</div>
                        }
                        <div className="library-label">{item.label}</div>
                      </div>
                    </div>
                  ))
                )
                }
              </div>
            </div>
          }
        </div>
      </div>
      {/* <div className="assessment-box">
        <img
          src={All}
          alt="Shared with me"
          className="assessment-icon"
        />
        <div>
          <div className="assessment-label">All</div>

          {loadingQuestions ?
            <div
              className="stu-card-title pt-2 col-md-12"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <i className="fas fa-spinner fa-spin"></i>
            </div>
            :
            <div className="assessment-count">{totalCountPublicAssessments || "0"}</div>
          }

        </div>
      </div> */}
    </div>
  );
}
